import SummaryItem from 'components/SummaryItem/SummaryItem'
import { translateManager as t } from 'services/TranslateManager'
import { promoCodeManager } from 'services/PromoCodeManager'
import { DISCOUNT_TYPES } from '../../../../../stores/promoCodeStore/promoCode.consts'
import { numberToText } from '../../../../../utils/utils'

function BuyOverMissingTiles({ buyOverData }) {
  if (buyOverData && buyOverData.missingTiles) {
    return (
      <SummaryItem
        highlighted
        text={
          buyOverData.missingTiles === 1
            ? t.get(
                'order.checkout.payment_summary_rows.add_one_more_to_get_discount',
                {
                  v1: promoCodeManager.getMetadata(DISCOUNT_TYPES.BUYOVER)
                    .buyOverDiscount,
                }
              )
            : t.get(
                'order.checkout.payment_summary_rows.add_many_more_to_get_discount',
                {
                  v1: numberToText(buyOverData.missingTiles),
                  v2: promoCodeManager.getMetadata(DISCOUNT_TYPES.BUYOVER)
                    .buyOverDiscount,
                }
              )
        }
      />
    )
  }
  return null
}

export default BuyOverMissingTiles
